import { useCallback } from 'react';
import TextBlockDomHelpers from '@nedoShared/modules/notes/block/textBlock/helpers/TextBlock.dom.helpers';
import TextBlockConstants from '@nedoShared/modules/notes/block/textBlock/TextBlock.constants';
import { ITextBlockDataAttr, } from '@nedoShared/modules/notes/block/textBlock/TextBlock.types';
const { EMPTY_TEXT_CODE } = TextBlockConstants;
const { getCaretPosition, setCaretPosition, getElement } = TextBlockDomHelpers;
export const useTextBlockInput = (containerRef, $store) => {
    const onTextInput = useCallback((e, caretInfo) => {
        const element = caretInfo.element.element;
        const value = element.textContent.replace(EMPTY_TEXT_CODE, '');
        $store.EDIT_TEXT_ELEMENT(element.id, { value });
    }, []);
    return useCallback((e) => {
        const caretInfo = getCaretPosition(containerRef.current);
        const element = getElement(caretInfo.node, containerRef.current);
        if (element &&
            (element.type === ITextBlockDataAttr.TEXT || element.type === ITextBlockDataAttr.INPUT)) {
            e.currentTarget.blur();
            e.preventDefault();
            if (element.type === ITextBlockDataAttr.INPUT) {
                const textContent = element.element.textContent.replace(EMPTY_TEXT_CODE, '');
                const value = textContent ? textContent : element.element.textContent;
                $store.EDIT_INPUT_ELEMENT(element.element.id, { value });
            }
            else if (element.type === ITextBlockDataAttr.TEXT) {
                onTextInput(e, caretInfo);
            }
            setTimeout(() => {
                if (element.type !== ITextBlockDataAttr.PLACEHOLDER) {
                    setCaretPosition(caretInfo.element.element, caretInfo.offset);
                }
            }, 0);
        }
        else {
            // alertWithConsoleLogging('useTextBlockInput: not found caretInfo', caretInfo)
        }
    }, []);
};
